import type { EventInfo } from '@models/Event'

import { request } from '../../../gateways/api'
import type { Project } from '../types/Project'

export { saveEvent }

const saveEvent = async (data: EventInfo): Promise<Project> => {
  const { id } = data

  const result = await request({
    url: `/rest/project/${id}/event`,
    method: 'POST',
    data,
  })

  return result
}
